// Session-storage cache for the calibration-center list fetched at login
// (/v1/calibrationcenters?pageNo=0&pageSize=500). The navbar location dropdown
// hydrates from this so it doesn't refetch on every mount. Cleared on logout/signout.
const CALIBRATION_CENTERS_KEY = 'calibration-centers'

export const setCachedCalibrationCenters = (centers) => {
  try {
    window.sessionStorage.setItem(CALIBRATION_CENTERS_KEY, JSON.stringify(Array.isArray(centers) ? centers : []))
  } catch {
    /* ignore — storage may be unavailable (private mode, quota) */
  }
}

export const getCachedCalibrationCenters = () => {
  try {
    const raw = window.sessionStorage.getItem(CALIBRATION_CENTERS_KEY)
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

export const clearCachedCalibrationCenters = () => {
  try {
    window.sessionStorage.removeItem(CALIBRATION_CENTERS_KEY)
  } catch {
    /* ignore */
  }
}
